import { Fragment, Key } from 'react'
import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/changelog',
    }),
  }
}

interface ListLog {
  date: string
  updates: string[]
}

const list = new Array(21).fill(0)

// TODO: API changelog parsing route
function Changelog() {
  const { t } = useTranslation()

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <Header>{t('changelog:header')}</Header>
        <Paragraph>{t('changelog:header-details')}</Paragraph>
        <Header2>{t('changelog:subheader')}</Header2>
        <Paragraph>{t('changelog:subheader-details')}</Paragraph>
        <div className='py-6'>
          {list.map((_, index: number) => {
            const v = t(`changelog-1:${index}`, null, {
              returnObjects: true,
            }) as ListLog

            if (!v?.updates) {
              return null
            }

            return (
              <Fragment key={`date-${index}` as Key}>
                <Header3 className='capitalize'>{v.date}</Header3>
                <ul className='list-disc py-2 px-6 space-y-0.5'>
                  {v.updates.map((n, i) => (
                    <li
                      key={`${index}-changelog-list-${i}`}
                      className={'md:text-lg text-gray-700 dark:text-gray-200'}
                    >
                      {n}
                    </li>
                  ))}
                </ul>
              </Fragment>
            )
          })}
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Changelog },
  {
    translation: 'changelog',
  }
)
